import request from '@/utils/http'
import { SRM, SRM_FILE, PFX } from '../constant/constant.js'

// 查询
export const queryPortrait = data => {
    return request({
        url: `${SRM}/suppliertInfo/queryTransportPortrait`,
        method: 'post',
        data,
    })
}

// 导出
export const exportPortrait = data => {
    return request({
        url: `${SRM_FILE}/exportTransportPortrait`,
        method: 'post',
        data,
    })
}

// 实际承运路线列表
export const getTransRecordsList = data => {
    return request({
        url: `${PFX}/supplierTransportRecords/list`,
        method: 'post',
        data,
    })
}

// 自行维护路线
export const querySelfLine = data => {
    return request({
        url: `${SRM}/suppliertInfo/querySelfLine`,
        method: 'post',
        data,
    })
}

// 评级详情
export const transportPortraitRateDetail = data => {
    return request({
        url: `${SRM}/supplierInfo/transportPortraitRateDetail`,
        method: 'post',
        data,
    })
}

// 详情查询
export const getPortraitDetail = data => {
    return request({
        url: `${SRM}/supplierInfo/getTransportPortraitDetail/${data.businessTypeId}`,
        method: 'get',
    })
}

// 查询天眼查信息
export const searchEyeInfo = params => {
    return request({
        url: `${SRM}/supplierRiskControlInfos/searchEyeInfo`,
        method: 'get',
        params,
    })
}
export const placeFuzzySearchByName = params => {
    return request({
        url: `${SRM}/dcApi/placeFuzzySearchByName`,
        method: 'get',
        params,
    });
};

// 数据更新接口
export const syncTransportPortrait = data => {
    return request({
        url: `${SRM}/supplierInfo/syncTransportPortrait`,
        method: 'post',
        data,
    });
};
